var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-action-sheet',{attrs:{"actions":_vm.clientList,"close-on-click-action":""},on:{"select":_vm.onSelect,"close":_vm.onClose},model:{value:(_vm.showClientList),callback:function ($$v) {_vm.showClientList=$$v},expression:"showClientList"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61459c9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/change-company.vue
// module id = null
// module chunks = 